// extracted by mini-css-extract-plugin
module.exports = {"root":"EmptyContent_root__1fwuo","centered":"EmptyContent_centered__HhYH1"};